import React from 'react';
import { get, post, put, del, patch } from '../../Utility/Http';
import { supportUserListGet, hotelListGet, supportCreatePost, supportCreateUpdate, assignBusinessListGet, auditHistoryListGet, supportUserUpdateGet, branchListGet } from '../Model/SupportUserModel';

export const supportUserList = async (data) => {
    const response = await get(`${process.env.EXTENDED_URL_WITHOUT_VERSION}users`, data);
    return supportUserListGet(response);
};
export const hotelList = async (data) => {
    const response = await get(`${process.env.EXTENDED_URL_WITHOUT_VERSION}org`, data);
    return hotelListGet(response);
};
export const supportCreate = async (data, id, type) => {
    if (type == 'post') {
        const response = await post(`${process.env.EXTENDED_URL_WITHOUT_VERSION}users`, data);
        return supportCreatePost(response);
    } else {
        const response_1 = await patch(`${process.env.EXTENDED_URL_WITHOUT_VERSION}users/${id}`, data);
        return supportCreateUpdate(response_1);
    }
};

export const assignBusinessList = async (data, id) => {
    const response = await get(`${process.env.EXTENDED_URL_WITHOUT_VERSION}users/user_details/${id}`, data);
    return assignBusinessListGet(response);
};

export const auditHistoryList = async (data, id) => {
    const response = await get(`${process.env.EXTENDED_URL}audit/history`, data);
    return auditHistoryListGet(response);
};
export const supportUserUpdate = async (data, id) => {
    const response = await patch(`${process.env.EXTENDED_URL_WITHOUT_VERSION}users/${id}`, data);
    return supportUserUpdateGet(response);
};

export const branchListApi = async (data, version = 'v4') => {
    const response = await get(`${process.env.EXTENDED_URL_WITHOUT_VERSION}${version}/org_branch`, data);
    return branchListGet(response);
};

